import { FilterGroup } from '../Tools/FilterGroup';
import { StorageTypeFilter } from '../Filters/StorageTypeFilter';
import { StorageElementDepth } from '../Elements/StorageElementDepth';
import { StorageElementHeight } from '../Elements/StorageElementHeight';
import { StorageElementType } from '../Elements/StorageElementType';
import { FiltersController } from '../Tools/FiltersController';
import { FiltersWidget } from '../FiltersWidget';
import { IFilter } from '../Tools/IFilter';
import { Events, eventsManager } from '@rhinov/savane-js';
import { _ASSET_TYPE, getAssets, getHandles } from '@rhinov/asset-manager-service';



export class StorageFilterWidget extends FilterGroup {

    constructor(container: string, storageElementsDepth: StorageElementDepth[],
        storageElementsHeight: StorageElementHeight[], storageElementsType: StorageElementType[]) {
        super();
        this.id = 'storage';
        this.name = 'Rangements';
        this.icon = 'fas fa-lg fa-cubes-stacked';
        this.resource = 'assets';
        this.filtersFunction = 'updateFilters';
        this.filters = [
            new StorageTypeFilter(this, storageElementsDepth, storageElementsHeight, storageElementsType)
        ];
        this.container = container;
        this.controller = new FiltersController();
    }

    static getInstance(): StorageFilterWidget | null {
        if (!FiltersWidget.filterGroups || FiltersWidget.filterGroups.length === 0) return null;
        return FiltersWidget.filterGroups.find((filterGroup: FilterGroup) => filterGroup.id === 'storage') as StorageFilterWidget || null;
    }

    generateStringFilter(): string {
        let stringFilters = '&q.pipeline.modelState.eq=validated&q.pipeline.state.in=available,archived&q.pipeline.unrealState.eq=ready';

        this.filters.forEach((filter: IFilter) => {
            stringFilters += filter.generateStringFilter();
        });

        return stringFilters;
    };

    update(): void {
        this.destroy();
        this.html();
    }

    selectionListener?: () => void;

    html(): void {
        this.isDestroyed = false;
        this.loadAllAssets().then(() => {
            this.selectionListener = () => { this.updateAllActiveLists(); };
            FilterGroup.addEntitySelectionListener(this.selectionListener);
            let html = this.filtersHtml() + `
            <div>
                <h style="font-weight:600;">Personnalisation</h>
                <div class="padding">
                    <div style="display:contents" id="Caisson-parent">
                        ${this.CaissonHtml()}
                    </div>
                    <div style="display:contents" id="Porte-parent">
                        ${this.PorteHtml()}
                    </div>
                    <div style="display:contents" id="Etagere-parent">
                        ${this.EtagereHtml()}
                    </div>
                    <div style="display:contents" id="Poignee-parent">
                        ${this.PoigneeHtml()}
                    </div>
                </div>
            </div>
            `;
            let container = document.getElementById(this.container);
            if (!container) {
                return;
            }
            container.innerHTML = html;
            eventsManager.instance.dispatch(Events.CAMERA_RESIZED);
        })
    }

    loadAllAssets(): Promise<void[]> {
        let cabinetPromise = this.getCabinetCoatings();
        let doorPromise = this.getAllDoorCoatings();
        let shelfPromise = this.getAllShelfCoatings();
        let handlePromise = this.getAllHandleModels();
        return Promise.all([cabinetPromise, doorPromise, shelfPromise, handlePromise]);
    }

    getCabinetCoatings(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreStorageCabinetCoatings.length !== 0) {
                resolve();
                return;
            }
            getAssets(_ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_LAPEYRE_RANGEMENT_COLORIS,COLORIS_GENERIQUES&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res: any) {
                var resources = res.data.resources;
                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreStorageCabinetCoatings = resources;
                    resolve();
                } else {
                    reject('No coatings found for Lapeyre storage cabinet');
                }
            });
        });
        return promise;
    }

    getAllDoorCoatings(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreStorageDoorCoatings.length !== 0) {
                resolve();
                return;
            }
            // Load all coatings for Lapeyre storage doors
            getAssets(_ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_LAPEYRE_RANGEMENT_COLORIS,CG_LAPEYRE_COLORIS_PORTE_2026,CG_LAPEYRE_RANGEMENT_COLORIS_GRANDE_PORTE,COLORIS_GENERIQUES&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res: any) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreStorageDoorCoatings = resources;
                    resolve();
                } else {
                    reject('Failed to load storage coatings !');
                }
            });
        });

        return promise;
    }

    getAllShelfCoatings(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreStorageShelfCoatings.length !== 0) {
                resolve();
                return;
            }
            // Load all coatings for Lapeyre storage doors
            getAssets(_ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_LAPEYRE_RANGEMENT_COLORIS,COLORIS_GENERIQUES&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res: any) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreStorageShelfCoatings = resources;
                    resolve();
                } else reject('Failed to load shelf coatings !');
            });
        });
        return promise;
    }

    getAllHandleModels(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreStorageHandleModels.length !== 0) {
                resolve();
                return;
            }
            // Load all handles for Lapeyre storage
            getHandles(FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&sort=name&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.manufacturer.eq=5eba5c37f3c97d07e6f83b5e', '670f6f295ab9af159dd955b5,6793a50125716ef37a5cc007', function (res: any) {
                var resources = res.data.resources;

                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreStorageHandleModels = resources;
                    resolve();
                } else reject('Failed to load handle models !');
            });
        });
        return promise;
    }

    updateActive(objects: any[], customName: string, isHandle?: boolean): void {
        objects.forEach((object: any) => {
            FilterGroup.cache.name = "";
            let isActive: boolean | undefined;
            if (isHandle) isActive = FilterGroup.isHandleUsed(object, FiltersWidget.ArrangementType.storageCustomizableArrangements);
            else isActive = FilterGroup.isCoatingUsed(object, customName, FiltersWidget.ArrangementType.storageCustomizableArrangements);

            let display = isActive ? "" : "none";
            $(`#active-${object.name}-${customName}`).css('display', display);
        })
    }

    updateAllActiveLists(): void {
        this.updateActive(FilterGroup.allLapeyreStorageCabinetCoatings, 'Caisson');
        this.updateActive(FilterGroup.allLapeyreStorageDoorCoatings, 'Porte');
        this.updateActive(FilterGroup.allLapeyreStorageShelfCoatings, 'Etagere');
    }

    getGenericHtml(coatings: any[], customName: string, getPreviewUrl: (coating: any) => string | null, title: string): string {
        FilterGroup.cache.name = "";
        let coatingsHtml = coatings.map((coating: any) => {
            setTimeout(() => {
                let listener = () => {
                    FilterGroup.updateArrangementCoating(coating, customName, FiltersWidget.ArrangementType.storageCustomizableArrangements);
                    this.updateActive(coatings, customName);
                }

                this.controller.addEventListener('click', listener, `div-${coating.name}-${customName}`);
                this.controller.addEventListener('click', listener, `img-${coating.name}-${customName}`);
            });

            const isUsed = FilterGroup.isCoatingUsed(coating, customName, FiltersWidget.ArrangementType.storageCustomizableArrangements);

            return `
                <div style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                    <div style="position:absolute;top:0px;left:0px;width:50px;height:50px;background-color:#f5d23100;"
                        title="${coating.name}" id="div-${coating.name}-${customName}">
                    </div>
                    <img style="width:50px;height:50px;" id="img-${coating.name}-${customName}" 
                        src="${getPreviewUrl(coating)}">
                    
                    <div id="active-${coating.name}-${customName}" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${isUsed ? '' : 'display:none'}">
                        <i class="fa-solid fa-check"></i>
                    </div>
                </div>
                `;
        }).join('');

        return `
        <div>
            <div style="text-align: left;">${title}</div>
            <div
                style="margin-bottom:10px;padding:0;width: 100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
                ${coatingsHtml}
            </div>
        </div>
        `;
    }

    CaissonHtml(): string {
        return this.getGenericHtml(
            FilterGroup.allLapeyreStorageCabinetCoatings,
            'Caisson',
            FilterGroup.getCabinetCoatingPreviewUrl,
            'Caissons'
        );
    }

    PorteHtml(): string {
        return this.getGenericHtml(
            FilterGroup.allLapeyreStorageDoorCoatings,
            'Porte',
            FilterGroup.getCabinetCoatingPreviewUrl,
            'Portes/Tiroirs'
        );
    }

    EtagereHtml(): string {
        return this.getGenericHtml(
            FilterGroup.allLapeyreStorageShelfCoatings,
            'Etagere',
            FilterGroup.getCabinetCoatingPreviewUrl,
            'Etagères'
        );
    }

    PoigneeHtml(): string {
        let handlesHtml = FilterGroup.allLapeyreStorageHandleModels.map((modele: any) => {
            setTimeout(() => {
                let listener = () => {
                    FilterGroup.updateArrangementHandleModeleType(modele, FiltersWidget.ArrangementType.storageCustomizableArrangements).then(() => {
                        this.updateActive(FilterGroup.allLapeyreStorageHandleModels, "Poignee", true);
                    });
                }

                this.controller.addEventListener('click', listener, `div-${modele.name}-Poignee`);
                this.controller.addEventListener('click', listener, `img-${modele.name}-Poignee`);
            });

            let isUsed = FilterGroup.isHandleUsed(modele, FiltersWidget.ArrangementType.storageCustomizableArrangements);
            return `
                <div style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                    <div style="position:absolute;top:0px;left:0px;width:50px;height:50px;background-color:#f5d23100;"
                        title="${modele.name}" id="div-${modele.name}-Poignee">
                    </div>
                    <img style="width:50px;height:50px;" src="${FilterGroup.getHandlePreviewUrl(modele)}" id="img-${modele.name}-Poignee">
                    
                    <div id="active-${modele.name}-Poignee" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${isUsed ? '' : 'display:none'}">
                        <i class="fa-solid fa-check"></i>
                    </div>
                </div>
            `;
        }).join('');

        setTimeout(() => {
            this.controller.addEventListener('click', (_: any) => {
                FilterGroup.removeArrangementHandleModel(FiltersWidget.ArrangementType.storageCustomizableArrangements);
                this.updateActive(FilterGroup.allLapeyreStorageHandleModels, "Poignee", true);
            }, 'noHandles');
        });
        return `
        <div>
            <div style="text-align: left;">Poignées</div>
            <div style="margin-bottom:10px;padding:0;width:100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
                ${handlesHtml}
                <div title="Pas de poignée" id="noHandles"
                    style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                    <i class="far fa-2x fa-trash-alt" style="vertical-align: middle;"></i>
                </div>
            </div>
        </div>
        `;
    }

    destroy(): void {
        super.destroy();
        if (this.selectionListener) {
            FilterGroup.removeEntitySelectionListener(this.selectionListener);
            this.selectionListener = undefined;
        }
    }
}